import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'appv2-music-filter',
  templateUrl: './music-filter.component.html',
  styleUrls: ['./music-filter.component.scss']
})
export class MusicFilterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
